import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import HomeContext from '../../../routes/context/homeContext';

import { api, homepageUploadDir } from '../../../config'
import { getDynamicTitleByLocale, getDynamicTitleByName } from '../../../helpers/getDynamicTitle';

import s from './SafetyGrid.css';
import bt from '../../../components/commonStyle.css';

class SafetyGrid extends React.Component {
  render() {
    const { dynamicHomePageSettings, currentLocale } = this.props;

    const homepage = this.context
    const apiEndpoint = api && api.apiEndpoint

    let allAppSectionData, appSectionData;
    allAppSectionData = getDynamicTitleByName({ dynamicHomePageSettings, name: 'safetyGridTitle1' });
    appSectionData = getDynamicTitleByLocale({ dynamicHomePageSettings: allAppSectionData, locale: currentLocale });
    appSectionData = appSectionData?.length > 0 ? appSectionData[0] : allAppSectionData[0];

    return (
      <Container className={s.containerWith}>
        <div className={cx(s.safetyContainer, 'safetyContainerTwoRTL', 'mobileSectionDark')} style={{ backgroundImage: `url(${api.apiEndpoint + homepageUploadDir + homepage.safetyGridImage4})` }}>
          <Row className={s.displayFlex}>
            <Col xl={5} md={6} sm={6} xs={12} className={cx(s.alignCenter)}>
              <img src={api.apiEndpoint + homepageUploadDir + homepage.safetyGridImage3} className={s.phoneImg} />
            </Col>
            <Col xl={7} md={6} sm={6} xs={12} className={'textAlignRightRTL'}>
              <div className={cx(s.signUp)}>
                <h3 className={'textWhite'}>
                  {appSectionData?.value}
                </h3>
                <p className={'textWhiteTwo'}>
                  {appSectionData?.description}
                </p>
              </div>
              <div className={cx(bt.paddingTop5, s.responsiveNoPadding)}>
                <div className={cx(s.displayInlineBlock, s.paddingRight, 'paddingRightRTLMb')}>
                  <a href={homepage.safetyGridLink2} target="_blank" >
                    <img src={api.apiEndpoint + homepageUploadDir + homepage.safetyGridImage2} className={s.appImg} />
                  </a>
                </div>
                <div className={cx(s.displayInlineBlock, s.paddingLeft, 'paddingLeftRTL')}>
                  <a href={homepage.safetyGridLink1} target="_blank" >
                    <img src={api.apiEndpoint + homepageUploadDir + homepage.safetyGridImage1} className={s.appImg} />
                  </a>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    );
  }
}
SafetyGrid.contextType = HomeContext
export default withStyles(s, bt)(SafetyGrid);
